import React from "react";
import { useTranslation } from "react-i18next";
import "./miniNavbar.scss";

const MiniNavbar = () => {

  const { t, i18n } = useTranslation()

  const changeLanguage = lng => {
    i18n.changeLanguage(lng)
    
  }


  return (
    <div className="container-mini-navbar">
      <div className="contact-mini-navbar">
        <p>{t("mini_navbar.contact_us_nav_text")} <a href="tel:+5511910160635"> +55 (11) 91016-0635 </a> &nbsp;&nbsp;|&nbsp;&nbsp; <a href="/form"> {t("mini_navbar.schedule_demo_text")} </a> </p>
      </div>
      <div className="menu-mini-navbar">
        <div className="item-menu-mini-navbar">
          <a href="/partnerships"><p>{t("mini_navbar.partners_nav_text")}</p></a>
        </div>
        <div className="item-menu-mini-navbar">
          <a href="/WhoWeAre"><p>{t("mini_navbar.company_nav_text")}</p></a>
        </div>
        <div className="item-menu-mini-navbar" style={{ border: "none" }}>
          <a href="/form">
            <p>{t("mini_navbar.contact_nav_text")}</p>
          </a>
        </div>
        <div className="item-menu-mini-navbar" style={{ border: "none", cursor: "pointer" }}>
          <a onClick={() => changeLanguage("pt-BR")}>
            <p className={`${i18n.language === "pt-BR" ? 'language-selected' : ''}`}>PT</p>
          </a>
        </div>
        <div className="item-menu-mini-navbar" style={{ border: "none", cursor: "pointer" }}>
          <a onClick={() => changeLanguage("en-US")}>
            <p className={`${i18n.language === "en-US" ? 'language-selected' : ''}`}>EN</p>
          </a>
        </div>

        <div className="item-menu-mini-navbar" style={{ border: "none", cursor: "pointer" }}>
          <a onClick={() => changeLanguage("es")}>
            <p className={`${i18n.language === "es" ? 'language-selected' : ''}`}>ES</p>
          </a>
        </div>

        {/* <div className="item-menu-mini-navbar">
          <p>LOGIN</p>
        </div>
        <div className="item-menu-mini-navbar" style={{border:"none"}}>
          <p>PT</p>
        </div> */}
      </div>
    </div>
  );
};
export default MiniNavbar;
